import { configureStore } from "@reduxjs/toolkit";
import { AuthReducer } from "./auth/authSlice";
import { FilterReducer } from "./filter/filterSlice";
import { CategoryReducer } from "./category/categorySlice";
import { CollectionPartnerReducer } from "./collectionPartners/collectionPartnerSlice";
import { ColorReducer } from "./color/colorSlice";
import { ProductReducer } from "./product/productSlice";
import { RawMaterialCategoryReducer } from "./rawMaterialCategory/rawMaterialCategorySlice";
import { RawMaterialVendorReducer } from "./rawMaterialVendor/rawMaterialVendorSlice";
import { RawMaterialReducer } from "./rawMaterial/rawMaterialSlice";
import { PortfolioReducer } from "./portfolio/portfolioSlice";
import { OfficeReducer } from "./office/officeSlice";
import { BlogReducer } from "./blog/blogSlice";
import { BlogCategoryReducer } from "./blogCategory/blogCategorySlice";
import { LeadReducer } from "./lead/leadSlice";
import { ProjectReducer } from "./project/projectSlice";
import { ProjectBoardReducer } from "./projectBoard/projectBoardSlice";
import { MeasurementRequestReducer } from "./measurementRequest/measurementRequestSlice";
import { PortalUserReducer } from "./portalUser/portalUserSlice";
import { InventoryReducer } from "./inventory/inventorySlice";
import { InventoryTransactionReducer } from "./inventoryTransaction/inventoryTransactionSlice";

const store = configureStore({
    reducer: {
        auth: AuthReducer,
        filter: FilterReducer,
        category: CategoryReducer,
        collectionPartner: CollectionPartnerReducer,
        color: ColorReducer,
        product: ProductReducer,
        rawMaterialCategory: RawMaterialCategoryReducer,
        rawMaterialVendor: RawMaterialVendorReducer,
        rawMaterial: RawMaterialReducer,
        portfolio: PortfolioReducer,
        office: OfficeReducer,
        blog: BlogReducer,
        blogCategory: BlogCategoryReducer,
        lead: LeadReducer,
        project: ProjectReducer,
        projectBoard: ProjectBoardReducer,
        measurementRequest: MeasurementRequestReducer,
        portalUser: PortalUserReducer,
        inventory: InventoryReducer,
        inventoryTransaction: InventoryTransactionReducer
    }
});

export default store;